<script lang="ts">
	// Info tab content for IR_REM-1-remote
</script>

<div class="info-content">
	<h3>Info Content for IR_REM-1-remote</h3>
	<p>This is the info tab content for the IR_REM-1-remote device.</p>
	<!-- Add your specific info content here -->
</div>

<style>
	.info-content {
		padding: 1rem;
	}
</style>
